import {
  createEndCustomer as APICreateEndCustomer,
  getEndCustomers,
  getEndCustomersByClientId,
  updateEndCustomer as APIUpdateEndCustomer,
  getEndCustomerByEndCustomerID,
} from "API/swesum";
import {
  createEndCustomer as APIMySiteCreateEndCustomer,
  getMyEndcustomers as APIMySiteGetEndCustomers,
  updateEndCustomer as APIMySiteUpdateEndCustomer,
  getEndCustomer as APIMySiteGetEndCustomer,
} from "API/myPages";
import { useAuth } from "Hooks/useAuth";
import { createContext, useContext, useState } from "react";
import { usePopupNotificationContext } from "Context/NotificationPopup";

const EndCustomerContext = createContext(null);

export const EndCustomerContextProvider = ({ children, clientId }) => {
  const { isAdmin } = useAuth();
  const [endCustomers, setEndCustomers] = useState([]);
  const [hasFetchedAll, setHasFetchedAll] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ready, setReady] = useState(false);

  const { openError } = usePopupNotificationContext();

  const fetchEndCustomers = async () => {
    setLoading(true);
    try {
      let data = null;
      if (hasFetchedAll) {
        return;
      }
      if (clientId) {
        data = await getEndCustomersByClientId(clientId);
      } else {
        data = isAdmin
          ? await getEndCustomers()
          : await APIMySiteGetEndCustomers();
      }
      setEndCustomers(data);
    } catch (err) {
      openError("Något gick fel vid hämtning av slutkunder");
      console.error(err);
    } finally {
      setReady(true);
      setHasFetchedAll(true);
      setLoading(false);
    }
  };

  const createEndCustomer = async (data) => {
    setLoading(true);
    const res = isAdmin
      ? await APICreateEndCustomer(data)
      : await APIMySiteCreateEndCustomer(data);
    setEndCustomers((prevEndCustomers) => [...prevEndCustomers, res.data]);
    setLoading(false);
    return res;
  };

  const updateEndCustomer = async (endCustomerId, body) => {
    const res = isAdmin
      ? await APIUpdateEndCustomer(endCustomerId, body)
      : APIMySiteUpdateEndCustomer(endCustomerId, body);
    if (res.status === 201) {
      const updateEndCustomer = res.data;
      setEndCustomers((currentEndCustomers) =>
        currentEndCustomers.map((endCustomer) =>
          endCustomer.Id === updateEndCustomer.Id
            ? { ...endCustomer, ...updateEndCustomer }
            : endCustomer
        )
      );
    }
    return res;
  };

  const getEndCustomerByEndCustomerId = async (endCustomerId) => {
    let res = endCustomers.find((cust) => cust.Id === endCustomerId);
    if (!res) {
      res = isAdmin
        ? await getEndCustomerByEndCustomerID(endCustomerId)
        : APIMySiteGetEndCustomer(endCustomerId);
    }
    return res;
  };

  return (
    <EndCustomerContext.Provider
      value={{
        endCustomers,
        fetchEndCustomers,
        getEndCustomerByEndCustomerId,
        createEndCustomer,
        updateEndCustomer,
        ready,
        loading,
      }}
    >
      {children}
    </EndCustomerContext.Provider>
  );
};

export const useEndCustomers = () => useContext(EndCustomerContext);
